import { useContext } from 'react';
import { DonorShieldContext } from '../context';
import { IWatrReimbursement, IWatrRequest, IWageAndTravelVerifyValidation } from '@nkr/models/index';
import {
    AdvancedWorkflowStatus,
    WageAndTravelCategory,
    WageAndTravelStatus
} from '@nkr/enums/index';
import { hasPendingTravelApprovalForWatr, isIntlStandardDerVerify, readAdvancedProgressForBuckets } from '../advanced-reimbursement-status-buckets';
import VerifyAmount from './verify-amount';
import VerifyStub from './verify-stub';
import VerifyTax from './verify-tax';
import VerifyTravel from './verify-travel';

interface IProps {
    data: IWatrRequest,
    isAudit: boolean,
    reimbursements: IWatrReimbursement[],
    category: WageAndTravelCategory,
    validation: IWageAndTravelVerifyValidation,
    isDirty: boolean,
}

function isAdvancedReimbursementTravelVerify(data: IWatrRequest): boolean {
    if (isIntlStandardDerVerify(data)) {
        return false;
    }
    if (data.status === WageAndTravelStatus.PendingAdvancedReimbursement) {
        return true;
    }
    const progress = readAdvancedProgressForBuckets(data);
    return progress?.onTrack === true
        || progress?.statusCode === AdvancedWorkflowStatus.PendingNkrVerification
        || progress?.statusCode === AdvancedWorkflowStatus.AwaitingDonorSubmission
        || progress?.statusCode === AdvancedWorkflowStatus.ReadyToReconcile;
}

const Verify = (props: IProps) => {
    const context = useContext(DonorShieldContext);

    const pendingTravel = hasPendingTravelApprovalForWatr(props.data);
    let isVerifyTravel =
        context.isNkrSuper
        && pendingTravel
        && (
            (props.data.donationConfirmed && props.category == WageAndTravelCategory.PendingDERVerify)
            || isIntlStandardDerVerify(props.data)
            || isAdvancedReimbursementTravelVerify(props.data)
        );

    let isVerifyWages =
        context.isNkrSuper
        && props.category == WageAndTravelCategory.PendingLWRVerify
        && props.data.status >= WageAndTravelStatus.PendingNkrVerifyTax
        && props.data.status <= WageAndTravelStatus.PendingNkrVerifyAmount;

    if (props.data.status == WageAndTravelStatus.PendingNkrVerifyAmount) {
        return (
            <VerifyAmount
                data={props.data}
                isAudit={props.isAudit}
                reimbursements={props.reimbursements}
            />
        );
    }

    if (props.data.status == WageAndTravelStatus.PendingNkrVerifyStub) {
        return (
            <VerifyStub
                data={props.data}
                isAudit={props.isAudit}
                reimbursements={props.reimbursements}
                validation={props.validation}
                isDirty={props.isDirty}
            />
        );
    }

    if (isVerifyWages) {
        return (
            <VerifyTax
                data={props.data}
                isAudit={props.isAudit}
                reimbursements={props.reimbursements}
                validation={props.validation}
                isDirty={props.isDirty}
            />
        );
    }

    if (isVerifyTravel) {
        return (
            <VerifyTravel
                data={props.data}
                isAudit={props.isAudit}
                reimbursements={props.reimbursements}
                category={props.category}
            />
        );
    }

    return null;
}

export default Verify;
